import { render } from "./Index.vue?vue&type=template&id=042d003a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=042d003a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-042d003a"

export default script